import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-svg-fut',
    templateUrl: './svg-fut.component.html',
    styleUrls: ['./svg-fut.component.css'],
    standalone: false
})
export class SvgFutComponent implements OnInit {
  @Input() darkcolor;
  @Input() lightcolor;

  constructor() { }

  ngOnInit() {
  }

}
